import React from "react";
import {useNavigate} from "react-router-dom";
import {useUser} from "../UserContext";

// A username that links to the user's profile when the user is a real (registered) user
const UserLink = ({user, style, className = ""}) => {
    const navigate = useNavigate()
    const myUser = useUser();

    if (!user) return null;

    const isOwn = myUser?.isLoggedIn && user.username === myUser.username;
    const clickable = isOwn || user.isActualUser || user.isLoggedIn;

    const goToUser = (event) => {
        event.stopPropagation();
        if (isOwn) {
            navigate('/my-profile')
        } else if (user.isActualUser || user.isLoggedIn) {
            navigate(`/profile?username=${encodeURIComponent(user.username)}`)
        }
    }

    if (!clickable) {
        return <span className={`user-link ${className}`} style={style}>{user.username}</span>
    }

    return (
        <button type="button" className={`user-link user-link--clickable ${className}`} style={style} onClick={goToUser}>
            {user.username}
        </button>
    )
}

export default UserLink;
